import React, { useCallback } from 'react'

import { Button, HStack, Icon, T, Text, VStack } from 'govwell-ui'

type Props = {
  topicName: string
  questionCount: number
  percentageOfTotal: number
  borderColor: string
  onViewAll?: () => void
}

const CategoryCard = ({
  topicName,
  questionCount,
  percentageOfTotal,
  borderColor,
  onViewAll,
}: Props) => {
  const handleViewAll = useCallback(() => {
    onViewAll?.()
  }, [onViewAll])

  return (
    <VStack
      gap={3}
      className="min-w-[280px] flex-1 rounded-lg border border-solid border-gray-200 bg-white p-4"
      style={{ borderTopColor: borderColor, borderTopWidth: 3 }}
    >
      <Text.BodyLarge className="line-clamp-2 font-bold">{topicName}</Text.BodyLarge>
      <HStack gap={2} align="center">
        <Icon icon="FaMessage" className="text-gray-500" />
        <Text.Body>
          <span className="font-bold">{questionCount}</span> questions
        </Text.Body>
        <Text.BodySmall className="text-gray-500">{percentageOfTotal}%</Text.BodySmall>
      </HStack>
      {onViewAll && (
        <Button
          variant="text"
          size="sm"
          onClick={handleViewAll}
          className="mt-auto w-full justify-center"
        >
          <HStack gap={2} align="center">
            <T>View All Questions</T>
            <Icon icon="FaArrowRight" />
          </HStack>
        </Button>
      )}
    </VStack>
  )
}

export default React.memo(CategoryCard)
